import { errorIfUninitialized, query } from './core';
import { URL_CARETEAM } from './urlConstants';

/**
 * A function that allows for querying careTeams. Add params to modify the request
 *
 * @param {array} params - An array of query strings. They will be joined with '&' and appended to the request URL
 * @returns promise
 */
export async function getCareTeams(params = []) {
  errorIfUninitialized();

  const finalParams = params.length > 0 ? params : '_count=200';

  const paramsString = `?${finalParams.join('&')}`;
  const response = await query(`${URL_CARETEAM}${paramsString}`);
  return response;
}
